import { useCallback, useEffect, useRef, useState } from 'react'
import { Bell } from 'lucide-react'
import { Link } from 'react-router-dom'
import { adminService } from '@services/adminService'

export default function AdminAttentionBadge() {
  const [count, setCount] = useState(null)
  const [available, setAvailable] = useState(true)
  const mountedRef = useRef(true)

  const load = useCallback(async () => {
    try {
      const response = await adminService.getAlertStats()
      if (!mountedRef.current) return
      setCount(Number(response?.unacknowledged || 0))
      setAvailable(true)
    } catch {
      if (!mountedRef.current) return
      setCount(null)
      setAvailable(false)
    }
  }, [])

  useEffect(() => {
    mountedRef.current = true
    load()
    const interval = setInterval(load, 30000)
    return () => {
      mountedRef.current = false
      clearInterval(interval)
    }
  }, [load])

  const label = available
    ? `${count || 0} unacknowledged operational alerts`
    : 'Operational alert count unavailable'

  return (
    <Link
      to="/admin/operations/mcp"
      className="relative inline-flex h-9 w-9 items-center justify-center text-gray-500 hover:bg-gray-100 hover:text-gray-950 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
      aria-label={label}
      title={label}
    >
      <Bell className="h-4 w-4" aria-hidden="true" />
      {count > 0 && (
        <span className="absolute right-0.5 top-0.5 flex h-4 min-w-4 items-center justify-center bg-red-600 px-1 text-[10px] font-semibold text-white">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  )
}
